import { render, staticRenderFns } from "./TheSnapshotAssignmentSubmitDialog.vue?vue&type=template&id=4c9e8644&"
import script from "./TheSnapshotAssignmentSubmitDialog.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotAssignmentSubmitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports